export var KPIValueFormat;
(function (KPIValueFormat) {
    KPIValueFormat["multiple"] = "multiple";
    KPIValueFormat["percent"] = "percent";
    KPIValueFormat["string"] = "string";
    KPIValueFormat["value"] = "value";
    KPIValueFormat["number"] = "number";
    KPIValueFormat["amount"] = "amount";
    KPIValueFormat["area"] = "area";
    KPIValueFormat["unit"] = "unit";
    KPIValueFormat["date"] = "date";
})(KPIValueFormat || (KPIValueFormat = {}));
export var SparklineTypes;
(function (SparklineTypes) {
    SparklineTypes["standard"] = "standard";
    SparklineTypes["colored"] = "colored";
})(SparklineTypes || (SparklineTypes = {}));
